module.exports = __webpack_public_path__ + "img/bgPro.2c833b5d.png";